import { createIcon } from '../icon'
import EyeOffIcon from '../svg/EyeOffIcon'

export const EyeOffIconDefault = createIcon(EyeOffIcon)
